module.exports = __webpack_public_path__ + "img/ms.93e8da99.svg";